<template>
  <resize-observer :breakpoints="breakpoints">
    <div
      slot-scope="{ el }"
      :class="el.is"
      class="sb-notifications"
    >
      <slide-list-transition>
        <template v-for="(notification, index) in notifications">
          <slot
            :notification="notification"
            :index="index"
          />
        </template>
      </slide-list-transition>
    </div>
  </resize-observer>
</template>

<script>
export default {
  name: 'Notifications',
  components: {},
  mixins: [],
  props: {
    notifications: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    breakpoints: {
      md: el => el.width < 615 && el.width > 240,
      sm: el => el.width <= 240
    }
  }),
  mounted () {},
  destroyed () {},
  watch: {},
  computed: {},
  methods: {},
  directives: {},
  filters: {},
  i18n: { messages: {} }
}
</script>

<style lang='scss'>
.sb-notifications {
  display: flex;
  flex-direction: column;
  &.md, &.sm {
    .sb-notification {
      flex-wrap: wrap;
      justify-content: space-between;
      .date-wrapper {
        order: 0;
      }
      .content-wrapper {
        order: 2;
        margin-right: 0;
        width: 100%;
        margin-top: 0.5em;
      }
      .actions-wrapper {
        order: 1;
      }
    }
  }
  &.sm {
    .sb-notification {
      .actions-wrapper {
        margin-top: 0.5em;
      }
    }
  }
}
</style>
